/** Raw theme colour custom properties read directly from CSS. */
export interface ThemeColors {
	bg: string;
	line: string;
	acc: string;
	err: string;
}

/** Reads the current theme colour custom properties directly from CSS.
 *  Works for both light and dark themes — the browser's CSS engine already
 *  resolved the correct values before this runs.                          */
export function readThemeColors(): ThemeColors {
	const style = getComputedStyle(document.documentElement);
	return {
		bg: style.getPropertyValue("--bg").trim(),
		line: style.getPropertyValue("--line").trim(),
		acc: style.getPropertyValue("--acc").trim(),
		err: style.getPropertyValue("--err").trim(),
	};
}
